import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=080fdad1&"
import script from "./TextInput.vue?vue&type=script&lang=js&"
export * from "./TextInput.vue?vue&type=script&lang=js&"
import style0 from "./TextInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VIcon,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080fdad1')) {
      api.createRecord('080fdad1', component.options)
    } else {
      api.reload('080fdad1', component.options)
    }
    module.hot.accept("./TextInput.vue?vue&type=template&id=080fdad1&", function () {
      api.rerender('080fdad1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/v2/schema/TextInput.vue"
export default component.exports